
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/best-claude-api-ui-for-testing",
      function () {
        return require("private-next-pages/best-claude-api-ui-for-testing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/best-claude-api-ui-for-testing"])
      });
    }
  